import 'url-search-params-polyfill';
/**
 * get meta object from meta tag fs-prop="analytics" on the main article (first article on the 3things)
 * @returns {object} Meta Object
 */
export const getPageMeta = () => {
	let data = {};
	let metaEl = document.querySelector('[fs-prop="analytics"]');
	if( ! metaEl ) return data;
	let atts = metaEl.attributes;
	for (let i=0,len=atts.length;i<len;i++) {
		if (atts[i].value) {
			let att = atts[i].name;
			let val = atts[i].value;

			att = (att.indexOf('-') >= 0) ? att.replace(/-/g, '_') : att;
			data[att] = val.trim();
		}
	}

	return data;
}

// query string helpers
export const setCampaignTraitsSession = () => {
	if (window.location.search.length == 0) return;

	const queryStr = window.location.search;
	const campaignTraits = {
		"org": "campaign_organization",
		"ag": "campaign_agency",
		"mc": "campaign_type",
		"src": "campaign_source",
		"cmp": "campaign_name",
		"add": "campaign_additional",
		"cmpid": "campaign_tracking_code"
	};	
	const query = new URLSearchParams(queryStr);
	const params = Object.keys(campaignTraits);
	let result;

	for (let key of query.keys()) {
		if (params.includes(key)) {
			if (!result) result = {};
			
			result[campaignTraits[key]] = query.get(key);
		}
	}

	if (result) {
		window.sessionStorage.setItem('sessionCampaignTraits', JSON.stringify(result));
	}

	return result;
};

export const getSessionCampaignTraits = () => {
	let result;

	try {
		result = JSON.parse(window.sessionStorage.getItem('sessionCampaignTraits'));
		if (!result) {
			result = setCampaignTraitsSession();
		}
	} catch (e) {
		return;
	}

	return result;
};

/*
`lastAnonymousProfileId`
 + populate when user hasn't logged in
 + pass blank on tracking when user is logged in
 + pass last anon id if user is logged out (?)

`lastKnownProfileId`
 + pass blank when user hasn't logged in
 + populate when user logs out
 + pass blank when user logs back in (?)
*/
export const getProfileData = (objData) => {
	const wisReg = window.wisRegistration;
	if (wisReg) {
		let isLoggedIn = wisReg.isUserLoggedIn();
		if (isLoggedIn) {
			const profileId = wisReg.getProfileId();
			objData.dcg_profile_id = profileId || '';
			sessionStorage.setItem('lastKnownProfileId', profileId);
		} 
		objData.lastKnownProfileId = sessionStorage.getItem('lastKnownProfileId') || '';
		
		let lastAnonProfileId = wisReg.getAnonProfileId() || sessionStorage.getItem('lastAnonymousProfileId');;
		objData.lastAnonymousProfileId = lastAnonProfileId || ''
		sessionStorage.setItem('lastAnonymousProfileId', objData.lastAnonymousProfileId);
	}
	return objData;
}

export const isObjectEmpty = (obj) => {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}